import { X, Maximize2, Minimize2 } from "lucide-react";
import React, { useEffect, useState } from "react";

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  size = "md",
  header = true,
  showFullScreen = true,
}) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) {
      document.addEventListener("keydown", handleEsc);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  // Reset fullscreen when modal closes
  useEffect(() => {
    if (!isOpen) {
      setIsFullscreen(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const sizeClasses = {
    sm: "max-w-md",
    md: "max-w-lg",
    lg: "max-w-2xl",
    xl: "max-w-4xl",
    xxl: "max-w-6xl",
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center">
      <div
        className="fixed inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      ></div>
      <div
        className={`relative bg-white rounded-lg shadow-xl w-full transition-all duration-300 ${
          isFullscreen
            ? "max-w-[98vw] max-h-[98vh] m-4"
            : `${sizeClasses[size]} mx-4 max-h-[97vh]`
        } overflow-hidden`}
      >
        {header && (
          <div className="flex items-center justify-between p-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900">{title}</h2>

            <div className="flex items-center gap-1">
              {showFullScreen && (
                <button
                  onClick={toggleFullscreen}
                  className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                  title={isFullscreen ? "Exit fullscreen" : "Fullscreen"}
                >
                  {isFullscreen ? (
                    <Minimize2 className="w-5 h-5 text-gray-500" />
                  ) : (
                    <Maximize2 className="w-5 h-5 text-gray-500" />
                  )}
                </button>
              )}
              <button
                onClick={onClose}
                className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                title="Close"
              >
                <X className="w-5 h-5 text-gray-500" />
              </button>
            </div>
          </div>
        )}
        <div
          className={`overflow-auto scrollbar-hide ${
            isFullscreen
              ? "max-h-[calc(98vh-64px)]"
              : "max-h-[calc(97vh-120px)]"
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
